const config = {
	nodeEnv: 'https://take5music.in/take5app1/studentApi/index.php/',
	phpEnv: 'https://news.take5music.in/api/',
	devEnv: 'https://take5music.in/take5app1/studentApiDev/index.php/',
};

export default config;
